import { render } from "./ImageName.vue?vue&type=template&id=de301038&scoped=true"
import script from "./ImageName.vue?vue&type=script&lang=js"
export * from "./ImageName.vue?vue&type=script&lang=js"

import "./ImageName.vue?vue&type=style&index=0&id=de301038&scoped=true&lang=css"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de301038"]])

export default __exports__